import React, { useEffect, useState } from "react";
import MultiSelect from "../MultiSelect/MultiSelect";
import {
  getroutinglevels,
  getroutinglevelsCountry,
  getroutinglevelsRegion,
} from "../../API/api";
import MultiSelectCm from "../MultiSelectCm/MultiSelectCm";
import MultiSelectCmTwo from "../MultiSelectCmTwo/MultiSelectCmTwo";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { filterDomainsForComponent2, getcurrentRoleValue } from "../../utils";
import { UserType } from "../cmOverview/UserType";
import { Home_PAGE_URL } from "../../Router/routerUrl";
import { useLocation } from "react-router-dom";
import ReusableMultiSelect from "../../NewComponent/ReusableMultiSelect";
import Styles from './cmRootFilter.module.css'
import { Select } from 'antd';
import debounce from "lodash.debounce";
import { useCallback } from 'react';
const filterDomainsForComponentData = (cmTopics) => {
  return Object.entries(cmTopics).map(([indexId, topic]) => ({
    indexId,
    name: topic,
    label: topic,
    value: topic,
  }));
};
const textStyles = {
  fontSize: "16px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word',overflowWrap: 'break-word',
  marginRight: "5px"  
};

export default function CmRootFilter() {
  const state = useSelector((state) => state.cmRoot);
  const userState = useSelector((state) => state.user);
  const cmOverviewReducer = useSelector((state) => state.cmOverview);
  const dispatch = useDispatch();
  const currentPath = useLocation();
  const [domain,setDomain] = useState(state.selectedDomainsObj||[]);
  const {
    cmRootRoutingData,
    cmRootUpdateRoutingVal,
    cmRootUpdateDomainVal,
    cmRootGetCountryData,
    cmRootGetRegionData,
    cmRootUpdateRegionVal,
    cmRootUpdateCountryVal,
    updatePageNoInSearchSuggestions,
    definedRegionObj,
    cmrUpdatePageNo,
  } = bindActionCreators(Actions, dispatch);
  
  console.log(domain,"domainvalue");
  const onChangeDomain = (data) => {
    setDomain(data);
    debouncedFetchOptions(data);
  };
  const debouncedFetchOptions = useCallback(
      debounce((data) => {
const selectedSet = new Set(data); // Faster lookup

    const updatedDomains = Object.entries(userState.cmTopics)
      .filter(([, topic]) => selectedSet.has(topic))
      .map(([indexId, topic]) => ({
        indexId,
        name: topic,
        label: topic,
        value: topic,
      }));

    // console.log("updatedDomains", updatedDomains);

    cmRootUpdateDomainVal(updatedDomains);
    updatePageNoInSearchSuggestions(0);
    cmrUpdatePageNo(1);
      }, 2000),
      []
    );
  const onChangeRoutingLevel = (data) => {
    // console.log("data", data)
    const result = state.routingData.find(item => item.label === data.label && item.value === data.value);
    // console.log("result",result)
    cmRootUpdateRoutingVal(result);
    updatePageNoInSearchSuggestions(0);
    cmrUpdatePageNo(1);
  };
  const onChangeGeoLevelCountry = (data) => {
    const obj2 = {
      name: data.key,
      label: data.label,
      value: data.value
    };
    updatePageNoInSearchSuggestions(0);
    cmRootUpdateCountryVal(obj2);
    cmrUpdatePageNo(1);
  };
  const onChangeGeoLevelRegion = (data) => {
  
    // let val={}
    const obj2 = {
      name: data.key,
      label: data.label,
      value: data.value
    };
    
    updatePageNoInSearchSuggestions(0);
    cmRootUpdateRegionVal(obj2);
    cmrUpdatePageNo(1);
  };
  const fetchCountryData = (parent) => {
    getroutinglevelsCountry(parent).then((res) => {
      if (res === undefined) return;
      cmRootGetCountryData(res);
    });
  };
  const fetchRegionData = () => {
    getroutinglevelsRegion().then((res) => {
      if (res === undefined) return;
      cmRootGetRegionData(res);
    });
  };
  const fetchRoutingLevel = () => {
    getroutinglevels().then((res) => {
      if (res === undefined) return;
      let geoData =
        userState.geoAttributes["attributes"][
        getcurrentRoleValue(userState.roles)
        ]["routingLevels"];
      if (geoData?.atr1 === undefined && geoData?.atr2 === undefined) {
        cmRootRoutingData(res.data.data);
        fetchCountryData();
        fetchRegionData();
      } else {
        if (geoData?.atr1 === undefined && geoData?.atr2 !== undefined) {
          cmRootRoutingData([res.data.data[0], res.data.data[1]]);
          definedRegionObj({
            name: geoData.atr2,
            label: geoData.atr2,
            value: geoData.atr2,
          });
          cmRootUpdateRegionVal({
            name: geoData.atr2,
            label: geoData.atr2,
            value: geoData.atr2,
          });
          fetchCountryData(geoData.atr2);
          fetchRegionData();
        }
        if (geoData.atr1 !== undefined && geoData.atr2 !== undefined) {
          cmRootRoutingData([res.data.data[0]]);
          cmRootUpdateCountryVal({
            name: geoData.atr1,
            label: geoData.atr1,
            value: geoData.atr1,
          });
        }
      }
      // cmRootRoutingData(res.data.data);
      cmRootUpdateDomainVal(filterDomainsForComponent2(userState.cmTopics));
    });
  };
  useEffect(() => {
    setDomain(state.selectedDomainsObj);
    if (state.routingData.length === 0) {
      fetchRoutingLevel();
    }
  }, [state]);

  
  return (
    <>
      <div
        style={{
          display: "flex",
          // justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {currentPath.pathname === "/cmHome/" && (
          <>
            {cmOverviewReducer.selectedTab === "1" ||
              cmOverviewReducer.selectedTab === "2" ||
              cmOverviewReducer.selectedTab === "4" ? (
              <>
                {/* <label style={{ marginTop: "-8px", marginRight: "5px" }}>
                  User Type:
                </label> */}
                <span style={textStyles}>
                User Type&nbsp;
                </span>
              </>
            ) : null}
          </>
        )}

        {/* <div style={{ display: "flex", alignItems: "baseline" }}> */}
        {currentPath.pathname === "/cmHome/" && (
          <>
            {cmOverviewReducer.selectedTab === "1" ||
              cmOverviewReducer.selectedTab === "2" ||
              cmOverviewReducer.selectedTab === "4" ? (
              <>
                <UserType />
              </>
            ) : null}
          </>
        )}

        <span style={{ marginLeft:  cmOverviewReducer.selectedTab === "3"?"0px":"5px" }}>
          {/* <MultiSelectCmTwo
            disabled={false}
            value={state.selectedDomainsObj}
            onChangeFunc={onChangeDomain}
            isMulti={true}
            options={filterDomainsForComponent2(userState.cmTopics)}
          /> */}
          <ReusableMultiSelect
            value={domain}
            onChange={onChangeDomain}
            options={filterDomainsForComponentData(userState.cmTopics)}
            placeholder="Select Domains"
            maxTagPlaceholder={`${domain?.length || 0} selected`}
            allowClear={true}
            disabled={false}
            zindexValue={false}
          />
        </span>
        <span style={{ marginLeft: "5px", display: "flex", width: "130px" }}>
          {/* <MultiSelectCm
            disabled={state.routingData.length === 1 ? true : false}
            value={state.selectedRouting}
            isMulti={false}
            onChangeFunc={onChangeRoutingLevel}
            options={state.routingData}
          /> */}
          <Select
            labelInValue
            options={state.routingData}
            value={state.selectedRouting}
            defaultValue={{
              "autoId": 3,
              "groupId": 1,
              "id": 3,
              "name": "global",
              "timeoutPeriod": 1515,
              "abortPeriod": 1586,
              "createdBy": null,
              "createdDate": null,
              "modifiedDate": null,
              "maxExpert": 2,
              "value": "global",
              "label": "Global"
            }}
            dropdownStyle={{ zIndex: 0, textAlign: "left" }}
            showSearch
            onChange={onChangeRoutingLevel}
            disabled={state.routingData.length === 1 ? true : false}
            // placeholder="Select Group"
            popupClassName={Styles.selectCss}
            size="middle"
            style={{ width: "100%", border: 'none', boxShadow: '0px 1px 2px 0px #1018280D', fontSize: '16px' }}

          />
        </span>
        <div style={{ marginLeft: "5px" ,display: "flex", width:state.selecetdRoutingValue === 1 ? "300px":"150px"}}>
          {state.selecetdRoutingValue === 1 && (
            // <MultiSelectCm
            //   disabled={state.routingData.length < 2 ? true : false}
            //   value={state.selectedGeoLevel}
            //   isMulti={false}
            //   onChangeFunc={onChangeGeoLevelCountry}
            //   options={state.countryData}
            // />
            <Select
              labelInValue
              options={state.countryData}
              showSearch
              value={state.selectedGeoLevel}
              defaultValue={state.selectedGeoLevel}
              onChange={onChangeGeoLevelCountry}
              disabled={state.routingData.length < 2 ? true : false}
              // placeholder="Select Group"
              popupClassName={Styles.selectCss}
              dropdownStyle={{ zIndex: 0, textAlign: "left" }}
              size="middle"
              style={{ width: "100%", border: 'none', boxShadow: '0px 1px 2px 0px #1018280D', fontSize: '16px' }}

            />
          )}
          {state.selecetdRoutingValue === 2 && (
            // <MultiSelectCm
            //   value={state.selectedGeoLevel}
            //   disabled={state.routingData.length < 3 ? true : false}
            //   isMulti={false}
            //   onChangeFunc={onChangeGeoLevelRegion}
            //   options={state.regionData}
            // />
   
            <Select
            labelInValue
            options={state.regionData}
            showSearch
            value={state.selectedGeoLevel}
            defaultValue={state.selectedGeoLevel}
            onChange={onChangeGeoLevelRegion}
            disabled={state.routingData.length < 3 ? true : false}
            // placeholder="Select Group"
            popupClassName={Styles.selectCss}
            dropdownStyle={{ zIndex: 0, textAlign: "left" }}
            size="middle"
            style={{ width: "100%", border: 'none', boxShadow: '0px 1px 2px 0px #1018280D', fontSize: '16px' }}

          />
     
          )}
          {/* </div> */}
        </div>
      </div>
    </>
  );
}
